import { render, staticRenderFns } from "./googleVision.vue?vue&type=template&id=54f5b919&scoped=true&"
import script from "./googleVision.vue?vue&type=script&lang=js&"
export * from "./googleVision.vue?vue&type=script&lang=js&"
import style0 from "./googleVision.vue?vue&type=style&index=0&id=54f5b919&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../integrationtest/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5b919",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f5b919')) {
      api.createRecord('54f5b919', component.options)
    } else {
      api.reload('54f5b919', component.options)
    }
    module.hot.accept("./googleVision.vue?vue&type=template&id=54f5b919&scoped=true&", function () {
      api.rerender('54f5b919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pointshop-widget/src/components/googleVision.vue"
export default component.exports